interface ApplicationStatusInterface {
    Submitted: string,
    Declined: string,
    Approved: string,
    ExpensesSubmitted: string,
    ExpensesApproved: string,
    ExpensesDeclined: string,
    ExpensesDue: string,
    ExpensesOverdue: string
}

export const ApplicationStatus: ApplicationStatusInterface = {
    Submitted: "Submitted",
    Declined: "Declined",
    Approved: "Approved",
    ExpensesSubmitted: "ExpensesSubmitted",
    ExpensesApproved: "ExpensesApproved",
    ExpensesDeclined: "ExpensesDeclined",
    ExpensesDue: "ExpensesDue",
    ExpensesOverdue: "ExpensesOverdue"
}
